import type { ReactNode } from 'react';

export const symbol_party_mode: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-120q-24 0-42-18t-18-42v-513q0-23 18-41.5t42-18.5h147l55-66q8-11 20-16t26-5h184q14 0 26 5t20 16l55 66h147q23 0 41.5 18.5T880-693v513q0 24-18.5 42T820-120H140Zm0-60h680v-513H645l-73-87H388l-73 87H140v513Zm340-257Zm0 171q69 0 119.5-46T650-426q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38 0 43-32.5 71.5T480-326h-97q-8.91 0-11.45 10-2.55 10 7.45 18 22 16 47.89 24 25.9 8 53.11 8ZM361.5-424.63q8.5-8.62 8.5-21.37 0-43 32.5-71.5T480-546h97q8.91 0 11.45-10 2.55-10-7.45-18-22-16-47.89-24-25.9-8-53.11-8-69 0-119.5 46T310-446q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63Z"
		/>
	</svg>
);
